import {
  MemberDrawerHeader,
  MemberDrawerRow
} from '@bo-components/members/drawer';
import { StatusIcon } from '@library/components/StatusIcon';
import type { Withdrawal } from '@library/types/payments';
import { formatMemberWithDrawalDetails } from '@bo-utils/members/memberPayments';

export interface MemberWithdrawalDrawerProps {
  onClose: () => void;
  withdrawal: Withdrawal;
}

export const MemberWithdrawalDrawer = ({
  onClose,
  withdrawal
}: MemberWithdrawalDrawerProps) => {
  const { merchantReferenceId, message, status } = withdrawal;

  const {
    createdDateTime,
    formattedAmount,
    formattedLatitude,
    formattedLongitude,
    formattedMethodDetails,
    formattedServiceDetails,
    stateAbbreviation,
    updatedDateTime,
    withdrawalStatus
  } = formatMemberWithDrawalDetails(withdrawal);

  return (
    <>
      {/* Header */}
      <MemberDrawerHeader onClose={onClose}>
        <p className="text-soClean-100 leading-none">Withdrawal</p>
        <div className="leading-none">
          <StatusIcon status={status} classes="!size-2 !mr-1.5" />
          <span className="text-soClean-100 text-xs">{withdrawalStatus}</span>
        </div>
      </MemberDrawerHeader>

      {/* Content */}
      <div
        className="flex flex-col gap-y-5 p-6"
        data-testid={`member-withdrawals-drawer-${merchantReferenceId}`}
      >
        <MemberDrawerRow
          dataTestId="withdrawal-id"
          label="Withdrawal ID"
          value={merchantReferenceId}
        />
        <MemberDrawerRow
          dataTestId="withdrawal-amount"
          label="Amount"
          value={formattedAmount}
        />
        <MemberDrawerRow
          dataTestId="withdrawal-method"
          label="Method"
          value={formattedMethodDetails}
        />
        {formattedServiceDetails && (
          <MemberDrawerRow
            dataTestId="withdrawal-service"
            label="Service"
            value={formattedServiceDetails}
          />
        )}
        <MemberDrawerRow
          dataTestId="withdrawal-state"
          label="State"
          value={stateAbbreviation}
        />
        <MemberDrawerRow
          dataTestId="withdrawal-latitude"
          label="Latitude"
          value={formattedLatitude}
        />
        <MemberDrawerRow
          dataTestId="withdrawal-longitude"
          label="Longitude"
          value={formattedLongitude}
        />
        <MemberDrawerRow
          dataTestId="withdrawal-createdAt"
          label="Created At"
          value={`${createdDateTime.date} at ${createdDateTime.time}`}
        />
        <MemberDrawerRow
          dataTestId="withdrawal-updatedAt"
          label="Updated At"
          value={`${updatedDateTime.date} at ${updatedDateTime.time}`}
        />
        {message && (
          <MemberDrawerRow
            dataTestId="withdrawal-error"
            label="Error"
            value={message}
          />
        )}
      </div>
    </>
  );
};
